import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DiagonalArrow, SwapArrows } from './icons';
import { glassSurface } from './glass';

type Props = {
  onReceive?: () => void;
  onSend?: () => void;
  onSwap?: () => void;
  /** Over a plain/light backdrop (e.g. sticky bar) — denser glass fill. */
  onLight?: boolean;
};

const GLASS_SURFACE = glassSurface('thin');
const LIGHT_SURFACE = glassSurface('regular');

function GlassButton({
  onClick,
  onLight,
  children,
}: {
  onClick?: () => void;
  onLight?: boolean;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative flex h-14 flex-1 items-center justify-center rounded-full transition-transform active:scale-[0.98]"
      style={onLight ? LIGHT_SURFACE : GLASS_SURFACE}
    >
      <span className="relative z-10 flex items-center justify-center gap-1.5">{children}</span>
    </button>
  );
}

export function SendReceiveButtons({ onReceive, onSend, onSwap, onLight }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full items-center gap-[8px]">
      <GlassButton onClick={onReceive} onLight={onLight}>
        <DiagonalArrow size={22} className="rotate-180 text-ink" />
        <span className="text-[13px] font-medium text-ink">{t('wallet.receive')}</span>
      </GlassButton>
      {onSwap && (
        <GlassButton onClick={onSwap} onLight={onLight}>
          <SwapArrows size={20} className="text-ink" />
          <span className="text-[13px] font-medium text-ink">{t('wallet.swap')}</span>
        </GlassButton>
      )}
      <GlassButton onClick={onSend} onLight={onLight}>
        <DiagonalArrow size={22} className="text-ink" />
        <span className="text-[13px] font-medium text-ink">{t('wallet.send')}</span>
      </GlassButton>
    </div>
  );
}
